import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'

import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

import 'uikit/dist/css/uikit.min.css'
import './index.css'


class Layout extends Component {

  componentDidMount() {
    try {
      this.UIkit = require("uikit/dist/js/uikit");
      this.Icons = require("uikit/dist/js/uikit-icons");
      this.UIkit.use(this.Icons);

    } catch (e) {
      console.error(e)
    }
  }

  render() {
    return (
      <div>
        <Helmet

        >
          <html lang="it" />
        </Helmet>

        <ToastContainer
          position="top-center"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnVisibilityChange={false}
          draggable
          pauseOnHover
        />

        <div>
          {this.props.children()}
        </div>

      </div>
    )
  }
}

Layout.propTypes = {
  children: PropTypes.func,
}

export default Layout


// WEBPACK FOOTER //
// ./src/layouts/index.js